import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '../view/homePage'
import About from '../view/about'
import PortfolioCompanies from '../view/portfolioCompanies'
import InvestorLogin from '../view/investorLogin'
import StaffLogin from '../view/staffLogin'
import Career from '../view/career'
import ContactUs from '../view/contactUs'
import Sitemap from '../view/sitemap'
import Disclaimer from '../view/disclaimer'
import PrivacyPolicy from '../view/privacyPolicy'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage
        },
        {
            path: '/about',
            name: 'About',
            component: About
        },
        {
            path: '/portfolioCompanies',
            name: 'PortfolioCompanies',
            component: PortfolioCompanies
        },
        {
            path: '/investorLogin',
            name: 'InvestorLogin',
            component: InvestorLogin
        },
        // {
        //     path: '/staffLogin',
        //     name: 'StaffLogin',
        //     component: StaffLogin
        // },
        {
            path: '/career',
            name: 'Career',
            component: Career
        },
        {
            path: '/contactUs',
            name: 'ContactUs',
            component: ContactUs
        },
        {
            path: '/sitemap',
            name: 'Sitemap',
            component: Sitemap
        },
        {
            path: '/privacyPolicy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy
        },
        {
            path: '/disclaimer',
            name: 'Disclaimer',
            component: Disclaimer
        },
    ]
})
